export default {
    du: {
        id: "du",
        label: "Deutsch",
        clear: "löschen",
        contact: "Kontakt",
        days: "Tage",
        email: "E-Mail",
        firstName: "Vorname",
        home: "Startseite",
        hours: "Stunden",
        info: "Info",
        lastName: "Nachname",
        logo: "Logo",
        message: "Nachricht",
        minutes: "Minuten",
        news: "Nachrichten",
        privacy: "Datenschutz",
        seconds: "Sekunden",
        send: "senden",
        team: "Team",
        video: "Video",
        sentences: {
            contactUs: "Kontaktieren Sie uns",
            emailErrorMessage: "Bitte wenden Sie sich für Support an <a href='mailto://support@f8th.ai'>support@f8th.ai</a>.",
            emailErrorTitle: "Oops... E-Mail nicht gesendet!",
            emailPolicy: "Durch Klicken auf <span class='colored'>SENDEN</span> bestätigen Sie, dass Sie unsere aktualisierte <span class='colored'>DATENSCHUTZERKLÄRUNG</span> gelesen haben und dass Ihre weitere Nutzung der Website diesen Richtlinien unterliegt.",
            emailSent: "E-Mail gesendet... Vielen Dank!",
            meetOurTeam: "Unser Team Kennenlernen",
            partnerWith: "In Partnerschaft mit",
            pleaseWait: "Bitte warten...",
            pleaseWrite: "Bitte schreiben Sie Ihre",
            seedRoundCountdown: "Countdown zur Seed-Runde",
        },
        slides: [
            {
                title: "Mehr Schutz mit weniger Komplikationen",
                subtitle: "Bietet passiven und kontinuierlichen Schutz gegen Account- und Sitzungsübernahmen, Web-Bots und interne Bedrohungen."
            },
            {
                title: "Stärken Sie Ihre Zero Trust Architecture (ZTA)",
                subtitle: "Verbessern Sie Ihre Sicherheit mit F8ths Verhaltensbiometrie für Zero Trust Architecture."
            },
            {
                title: "Kontinuierliche Authentifizierung",
                subtitle: "Authentifiziert Benutzer transparent und passiv und erkennt Betrüger in Echtzeit, ohne das Benutzererlebnis zu beeinträchtigen."
            },
            {
                title: "Patentiertes nicht-invasives Biometrie-Verfahren",
                subtitle: "Verhaltensbiometrie der nächsten Generation für verbesserte Sicherheit."
            }
        ],
        infoSlides: [
            {
                title: "Mehr Schutz",
                description: "Erleben Sie erhöhte Sicherheit mit F8th Inc.'s Lösung für Verhaltensbiometrie. Unsere kontinuierliche Authentifizierung schützt Ihre Konten und Sitzungen und verteidigt gegen Bedrohungen wie Übernahmen, Bots und interne Angriffe. Erzielen Sie robusten Schutz ohne den Aufwand komplexer Prozesse."
            },
            {
                title: "Gestärkte ZTA",
                description: "Stärken Sie Ihre Zero Trust Architecture (ZTA) mit F8th Inc.'s fortschrittlicher Verhaltensbiometrie. Unsere Technologie bietet kontinuierliche Authentifizierung und stärkt Ihre Sicherheitsposition, indem sie vor Account-Übernahmen und internen Bedrohungen schützt. Stärken Sie das Sicherheitsframework Ihrer Organisation noch heute."
            },
            {
                title: "Kontinuierliche Authentifizierung",
                description: "Erhöhen Sie Ihre Sicherheitsmaßnahmen mit F8th Inc.'s kontinuierlicher Authentifizierung. Unsere Lösung nutzt Verhaltensbiometrie, um einen nahtlosen und hochsicheren Authentifizierungsprozess zu gewährleisten. Ergreifen Sie proaktiv Maßnahmen zum Schutz Ihrer digitalen Vermögenswerte."
            },
            {
                title: "Biometrie-Innovation",
                description: "Erleben Sie die Zukunft der verbesserten Sicherheit mit F8th Inc.'s patentiertem, nicht-invasivem Biometrie-Verfahren. Unsere fortschrittliche Verhaltensbiometrie bietet modernsten Schutz vor Bedrohungen, ohne die Privatsphäre der Benutzer zu beeinträchtigen. Bleiben Sie mit unserem innovativen Ansatz einen Schritt voraus."
            }
        ],
        investorPanels: [
            {
                title: "Betrachtete<br />Investoren",
                description: "Über 1000 VC-Fonds wurden als potenzielle Partner identifiziert, die in SEED-Runden in den Bereichen Fintech oder Cybersicherheit investiert haben."
            },
            {
                title: "Etablierte<br />Verbindungen",
                description: "Basierend auf spezifischeren Auswahlkriterien wurden VCs darüber informiert, dass wir bald eine Runde eröffnen werden."
            },
            {
                title: "Passende<br />Profile",
                description: "Nach Treffen mit potenziellen Partnern wird eine gemeinsame Entscheidung getroffen, um das Interesse beider Parteien zu bestätigen."
            },
            {
                title: "Unverbindliche<br />Zusagen",
                description: "Wir akzeptieren unverbindliche Zusagen vor der Eröffnung der Runde. Auf diese Weise wissen wir, wer Teil dieser Cybersecurity-Revolution sein möchte!"
            },
        ],
        teamPanels: [
            {
                name: "Jonathan Gagné",
                title: "Gründer/Geschäftsführer",
                linkedin: "jonathan-gagne",
                bio: "Mit umfassender Expertise in Cybersicherheit, Softwareentwicklung und Datenwissenschaft leitet Jonathan die geschäftliche und technologische Entwicklung von F8th.",
            },
            {
                name: "Vivene Salmon",
                title: "Mitgründerin/Leiterin der Rechtsabteilung",
                linkedin: "vivene-salmon-gagne",
                bio: "Vorherige Präsidentin der Canadian Bar Association und Datenschutzbeauftragte der Bank of America. Vivene wurde als eine der „25 einflussreichsten Anwälte in Kanada“ nominiert.",
            },
            {
                name: "Stephen Strome",
                title: "Technologiechef",
                linkedin: "stephen-strome-27187010b",
                bio: "Stephen, F8th's Technologiechef, ist nicht nur ein hochqualifizierter Profi, sondern auch ein vertrauenswürdiger Vertrauter des CEO mit jahrelanger vertrauensvoller Zusammenarbeit.",
            },
            {
                name: "Daniel Steeves",
                title: "CIO",
                linkedin: "daniel-steeves-1527b55",
                bio: "Ehemaliger CIO des Ottawa Police Service und Militäroffizier für National Defense. Daniel ist dem F8th-Team beigetreten, um seine Expertise in das Unternehmen einzubringen.",
            },
            {
                name: "Nir Ben-David",
                title: "CSO",
                linkedin: "benda-ican",
                bio: "Mit einer herausragenden militärischen Karriere als Brigadegeneral (Res.) und visionärem Unternehmertum, das wirtschaftliche Beziehungen zwischen Israel und Kanada fördert, treibt uns Benda, unser Chief Strategy Officer, zu neuen Höhen des Erfolgs an."
            },
            {
                name: "Kartik Khatri",
                title: "Executive Assistant",
                linkedin: "kartikkhatri",
                bio: "Der erste Student, der an der University of Toronto einen dreifachen Abschluss in Mathematik, Statistik und Wirtschaftswissenschaften erworben hat. Er ist ein schlauer Kopf und hat mehrere Tricks auf Lager, um das Unternehmen zu unterstützen.",
            },
            {
                name: "Peter Norvig",
                title: "Berater",
                linkedin: "pnorvig",
                bio: "Peter Norvig, angesehener Education Fellow an der Stanford University und ehemaliger Direktor für Forschung bei Google, ist ein hoch angesehener Berater für F8th Inc. Seine Expertise in KI, NLP und maschinellem Lernen bringt unschätzbare Erkenntnisse in unsere Organisation ein.",
            },
            {
                name: "Mark Smith",
                title: "Berater",
                linkedin: "smithamark",
                bio: "Ehemaliger Direktor bei Amazon, Venture-Capital-Investor, Partner bei BDC, Mentor und Coach. Mark unterstützt F8th bei der Entwicklung von Geschäftsstrategien.",
            },
            {
                name: "Bradley Schaufenbuel",
                title: "Berater",
                linkedin: "bradleyschaufenbuel",
                bio: "Bradley J. Schaufenbuel, Vice President und Chief Information Security Officer bei Paychex, ist ein erstaunlicher und großzügiger Berater mit beeindruckendem Hintergrundwissen in Informationssicherheit, Governance und Recht.",
            },
            {
                name: "Lee Bowie",
                title: "Berater",
                linkedin: "lee-bowie",
                bio: "IBM Cloud and Cognitive Technology Canada National Team Leader. Lee ist ein Freund und wichtiger Berater für die strategische Ausrichtung und Integration von F8th in Cloud-Technologien.",
            },
            {
                name: "Garry Chan",
                title: "Berater",
                linkedin: "garrychan1",
                bio: "Ein seit vielen Jahren tätiger Serienunternehmer mit fundiertem Verständnis für innovative Technologien. Garry ist ein wichtiger Berater für F8ths Geschäftswachstumsstrategien.",
            },
            {
                name: "Caroline Belisle Therrien",
                title: "Beraterin",
                linkedin: "carolinebelisletherrien",
                bio: "Caroline ist eine außergewöhnliche Beraterin mit umfangreichen Kenntnissen in den Bereichen Fintech und Cybersicherheit. Sie bringt unschätzbare Expertise und Leidenschaft dafür mit, stets auf dem neuesten Stand der technologischen Entwicklungen zu bleiben.",
            },
            {
                name: "Samuel Lemay",
                title: "Berater",
                linkedin: "samlemay",
                bio: "Ehemaliger Chief Commercial Officer von F8th Inc. Samuel bringt umfangreiche Expertise im globalen Technologievertrieb mit und ist somit ein unschätzbarer Berater für das Unternehmen.",
            },
            {
                name: "Sebastien Roy",
                title: "Berater",
                linkedin: "sebastienroy",
                bio: "Sebastiens Fachkenntnisse in Mathematik, Optimierung und Datenwissenschaft sowie seine Führungsqualitäten und Erfahrung im Start-up-Bereich machen ihn zu einem wertvollen Berater für das Wachstum des Unternehmens."
            },
            // {
            //     name: "Nadia Tahiri",
            //     title: "Beraterin",
            //     linkedin: "tahiri-nadia",
            //     bio: "Dr. Nadia Tahiri, PhD, ist eine wertvolle Beraterin für F8th Inc. und bringt Expertise in Informatik, maschinellem Lernen und Bioinformatik mit. Ihre Erfahrung als Professorin und Forscherin bietet wertvolle Orientierungshilfe.",
            // },
        ]
    },
    en: {
        id: "en",
        label: "English",
        clear: "clear",
        contact: "Contact",
        days: "Days",
        email: "Email",
        firstName: "First Name",
        home: "Home",
        hours: "Hours",
        info: "Info",
        lastName: "Last Name",
        logo: "Logo",
        message: "Message",
        minutes: "Minutes",
        news: "News",
        privacy: "Privacy",
        seconds: "Seconds",
        send: "send",
        team: "Team",
        video: "Video",
        sentences: {
            contactUs: "Contact Us",
            emailErrorMessage: "Please contact the customer support at <a href='mailto://support@f8th.ai'>support@f8th.ai</a>.",
            emailErrorTitle: "Oops... Email not sent!",
            emailPolicy: "By clicking <span class='colored'>SEND EMAIL</span>, you acknowledge that you have read our updated <span class='colored'>PRIVACY POLICY</span>, and that your continued use of the website is subject to these policies.",
            emailSent: "Email sent... Thanks!",
            meetOurTeam: "Meet our Team",
            partnerWith: "Partnered with",
            pleaseWait: "Please wait...",
            pleaseWrite: "Please write your",
            seedRoundCountdown: "Seed Round Countdown",
        },
        slides: [
			{
				title: "More Protection with Less Complication",
				subtitle: "Protects passively and continuously against account and session takeovers, web bots and insider threats."
			},
			{
				title: "Strengthen your Zero Trust Architecture (ZTA)",
				subtitle: "Enhance your security with F8th's behavioral biometrics for Zero Trust Architecture."
			},
			{
				title: "Continuous Authentication",
				subtitle: "Transparently and passively authenticates users and detects fraudsters in real-time without impacting the user experience."
			},
			{
				title: "Patent-Pending Non-Invasive Biometry",
				subtitle: "Next-generation behavioral biometrics for enhanced security."
			}
		],
        infoSlides: [
			{
				title: "More Protection",
				description: "Experience enhanced security with F8th Inc.'s behavioral biometrics solution. Our continuous authentication safeguards your accounts and sessions, defending against threats like takeovers, bots, and insider attacks. Achieve robust protection without the hassle of complex processes."
			},
			{
				title: "ZTA Strengthened",
				description: "Fortify your Zero Trust Architecture (ZTA) with F8th Inc.'s advanced behavioral biometrics solution. Our technology provides continuous authentication, bolstering your security posture and protecting against account takeovers and insider threats. Strengthen your organization's security framework today."
			},
			{
				title: "Continuous Authentication",
				description: "Elevate your security measures with F8th Inc.'s continuous authentication. By leveraging behavioral biometrics, our solution ensures a seamless and highly secure authentication process. Take a proactive step towards safeguarding your digital assets."
			},
			{
				title: "Biometry Innovation",
				description: "Experience the future of enhanced security with F8th Inc.'s patent-pending non-invasive biometry solution. Our advanced behavioral biometrics provide cutting-edge protection against threats without compromising user privacy. Stay one step ahead with our innovative approach."
			}
		],
        investorPanels: [
            {
                title: "Considered<br />Investors",
                description: "Over 1000 VC funds have been identified to be a potential partner investing on SEED rounds in Fintech or Cybersecurity."
            },
            {
                title: "Connections<br />Established",
                description: "Based on more specific selection criterias, VCs have been made aware that we are opening a round soon."
            },
            {
                title: "Matching<br />Profiles",
                description: "After meeting with potential partners, a common decision is made to confirm interest from both parties."
            },
            {
                title: "Soft<br />Commitments",
                description: "We are accepting soft commitments prior to opening the round. This way, we know who wants to be part of this Cybersecurity revolution!"
            },
        ],
        teamPanels: [
            {
                name: "Jonathan Gagne",
                title: "Founder/CEO",
                linkedin: "jonathan-gagne",
                bio: "With in-depth expertise in cybersecurity, software engineering and data science, Jonathan leads the business and technological development of F8th.",
            },
            {
                name: "Vivene Salmon",
                title: "Co-Founder/CLO",
                linkedin: "vivene-salmon-gagne",
                bio: "Previously President of the Canadian Bar Association and Privacy Officer for the Bank of America, Vivene has been nominated « Top 25 most influential lawyers in Canada ».",
            },
            {
                name: "Stephen Strome",
                title: "CTO",
                linkedin: "stephen-strome-27187010b",
                bio: "Stephen, F8th's CTO, is not only a highly skilled professional but also a trusted confidant of the CEO, with years of collaborative friendship.",
            },
            {
                name: "Daniel Steeves",
                title: "CIO",
                linkedin: "daniel-steeves-1527b55",
                bio: "Formerly CIO for the Ottawa Police Service and Military Officer for National Defense, Daniel joined the F8th team to bring his expertise to the company.",
            },
            {
                name: "Nir Ben-David",
                title: "CSO",
                linkedin: "benda-ican",
                bio: "With a distinguished military background as a Brigadier General (Res') and visionary entrepreneurship fostering economic ties between Israel and Canada, Benda, our Chief Strategy Officer, propels us to new heights of success.",
            },
            {
                name: "Kartik Khatri",
                title: "Executive Assistant",
                linkedin: "kartikkhatri",
                bio: "The first student to earn a triple major in mathematics, statistics and economics at the University of Toronto. He is a smart cookie and has multiple tricks in his hat to leverage the company.",
            },
            {
                name: "Peter Norvig",
                title: "Advisor",
                linkedin: "pnorvig",
                bio: "Peter Norvig, esteemed Education Fellow at Stanford and former Director of Research at Google, is a highly esteemed advisor for F8th Inc. His expertise in AI, NLP, and machine learning brings invaluable insights to our organization.",
            },
            {
                name: "Mark Smith",
                title: "Advisor",
                linkedin: "smithamark",
                bio: "Former Director at Amazon, Venture Capital investor, Partner at BDC, mentor and coach, Mark is helping F8th with business development strategies.",
            },
            {
                name: "Bradley Schaufenbuel",
                title: "Advisor",
                linkedin: "bradleyschaufenbuel",
                bio: "Bradley J. Schaufenbuel, the Vice President and Chief Information Security Officer at Paychex, is an amazing and generous advisor with an impressive background in information security, governance, and law.",
            },
            {
                name: "Lee Bowie",
                title: "Advisor",
                linkedin: "lee-bowie",
                bio: "IBM Cloud and Cognitive Technology Canada National Team Leader. Lee is a friend and a key advisor for the strategic direction and integration of F8th within cloud technologies.",
            },
            {
                name: "Garry Chan",
                title: "Advisor",
                linkedin: "garrychan1",
                bio: "A serial entrepreneur for many years with a deep understanding of innovative technologies, Garry is a key advisor on F8th's business growth strategies.",
            },
            {
                name: "Caroline Belisle Therrien",
                title: "Advisor",
                linkedin: "carolinebelisletherrien",
                bio: "Caroline is an exceptional advisor with extensive knowledge in Fintech and Cybersecurity, bringing invaluable expertise and a passion for staying up-to-date with the latest technological advancements.",
            },
            {
                name: "Samuel Lemay",
                title: "Advisor",
                linkedin: "samlemay",
                bio: "Formerly serving as F8th Inc.'s Chief Commercial Officer, Samuel brings a wealth of expertise in global technology commercialization, making him an invaluable advisor to the company.",
            },
            {
                name: "Sebastien Roy",
                title: "Advisor",
                linkedin: "sebastienroy",
                bio: "Sebastien's expertise in mathematics, optimization, and data science, combined with leadership skills and startup experience, make him a valuable advisor for scaling the company.",
            },
            // {
            //     name: "Nadia Tahiri",
            //     title: "Advisor",
            //     linkedin: "tahiri-nadia",
            //     bio: "Dr. Nadia Tahiri, PhD, is a valuable advisor for F8th Inc., bringing expertise in computer science, machine learning, and bioinformatics. Her experience as a professor and researcher provides insightful guidance.",
            // },
        ]
    },
    es: {
        id: "es",
        label: "Español",
        clear: "limpiar",
        contact: "Contacto",
        days: "Días",
        email: "Correo electrónico",
        firstName: "Nombre",
        home: "Inicio",
        hours: "Horas",
        info: "Información",
        lastName: "Apellido",
        logo: "Logo",
        message: "Mensaje",
        minutes: "Minutos",
        news: "Noticias",
        privacy: "Privacidad",
        seconds: "Segundos",
        send: "enviar",
        team: "Equipo",
        video: "Video",
        sentences: {
            contactUs: "Contáctenos",
            emailErrorMessage: "Por favor, contacte al soporte al cliente en <a href='mailto://support@f8th.ai'>support@f8th.ai</a>.",
            emailErrorTitle: "¡Ups... Email no enviado!",
            emailPolicy: "Al hacer clic en <span class='colored'>ENVIAR EMAIL</span>, usted reconoce que ha leído nuestra <span class='colored'>POLÍTICA DE PRIVACIDAD</span> actualizada, y que su uso continuado del sitio web está sujeto a estas políticas.",
            emailSent: "Email enviado... ¡Gracias!",
            meetOurTeam: "Conoce a Nuestro Equipo",
            partnerWith: "Socio de",
            pleaseWait: "Por favor espere...",
            pleaseWrite: "Por favor escriba su",
            seedRoundCountdown: "Cuenta regresiva de la ronda inicial",
        },
        slides: [
            {
                title: "Más Protección con Menos Complicaciones",
                subtitle: "Protege de forma pasiva y continua contra la toma de cuentas y sesiones, bots web y amenazas internas.",
            },
            {
                title: "Fortalezca su Arquitectura de Confianza Cero (ZTA)",
                subtitle: "Mejore su seguridad con la biometría del comportamiento de F8th para la Arquitectura de Confianza Cero.",
            },
            {
                title: "Autenticación Continua",
                subtitle: "Autentica de forma transparente y pasiva a los usuarios y detecta a los estafadores en tiempo real sin afectar la experiencia del usuario.",
            },
            {
                title: "Biometría No Invasiva con Patente Pendiente",
                subtitle: "Biometría del comportamiento de última generación para una seguridad mejorada.",
            },
        ],
        infoSlides: [
            {
                title: "Más Protección",
                description: "Experimente una seguridad mejorada con la solución de biometría del comportamiento de F8th Inc. Nuestra autenticación continua protege sus cuentas y sesiones, defendiéndolas de amenazas como la toma de control, los bots y los ataques internos. Obtenga una protección sólida sin la molestia de procesos complejos.",
            },
            {
                title: "Fortaleza en ZTA",
                description: "Fortalezca su Arquitectura de Confianza Cero (ZTA) con la avanzada solución de biometría del comportamiento de F8th Inc. Nuestra tecnología proporciona autenticación continua, fortaleciendo su postura de seguridad y protegiéndola contra la toma de cuentas y las amenazas internas. Refuerce el marco de seguridad de su organización hoy mismo.",
            },
            {
                title: "Autenticación Continua",
                description: "Eleve sus medidas de seguridad con la autenticación continua de F8th Inc. Mediante el aprovechamiento de la biometría del comportamiento, nuestra solución garantiza un proceso de autenticación fluido y altamente seguro. Dé un paso proactivo para proteger sus activos digitales.",
            },
            {
                title: "Innovación en Biometría",
                description: "Experimente el futuro de la seguridad mejorada con la solución de biometría no invasiva con patente pendiente de F8th Inc. Nuestra avanzada biometría del comportamiento brinda una protección de vanguardia contra amenazas sin comprometer la privacidad del usuario. Manténgase un paso adelante con nuestro enfoque innovador.",
            },
        ],
        investorPanels: [
            {
                title: "Inversionistas Considerados",
                description: "Se han identificado más de 1000 fondos de capital de riesgo como posibles socios para invertir en rondas iniciales en las áreas de Fintech o Ciberseguridad.",
            },
            {
                title: "Conexiones Establecidas",
                description: "Según criterios de selección más específicos, se ha informado a los inversores de capital de riesgo que estamos por abrir una ronda próximamente.",
            },
            {
                title: "Perfiles Coincidentes",
                description: "Después de reunirse con posibles socios, se llega a una decisión común para confirmar el interés de ambas partes.",
            },
            {
                title: "Compromisos Flexibles",
                description: "Estamos aceptando compromisos flexibles antes de abrir la ronda. ¡De esta manera, sabemos quién quiere formar parte de esta revolución en ciberseguridad!",
            },
        ],
        teamPanels: [
            {
                name: "Jonathan Gagné",
                title: "Fundador/CEO",
                linkedin: "jonathan-gagne",
                bio: "Con una amplia experiencia en ciberseguridad, ingeniería de software y ciencia de datos, Jonathan lidera el desarrollo empresarial y tecnológico de F8th.",
            },
            {
                name: "Vivene Salmon",
                title: "Co-Fundadora/CLO",
                linkedin: "vivene-salmon-gagne",
                bio: "Anteriormente, presidenta de la Asociación del Colegio de Abogados de Canadá y Oficial de Privacidad del Bank of America, Vivene ha sido nominada como una de las «25 abogadas más influyentes de Canadá».",
            },
            {
                name: "Stephen Strome",
                title: "CTO",
                linkedin: "stephen-strome-27187010b",
                bio: "Stephen, CTO de F8th, no solo es un profesional altamente capacitado, sino también un confidente de confianza del CEO, con años de amistad colaborativa.",
            },
            {
                name: "Daniel Steeves",
                title: "CIO",
                linkedin: "daniel-steeves-1527b55",
                bio: "Anteriormente CIO del Servicio de Policía de Ottawa y Oficial Militar de Defensa Nacional, Daniel se unió al equipo de F8th para aportar su experiencia a la empresa.",
            },
            {
                name: "Nir Ben-David",
                title: "CSO",
                linkedin: "benda-ican",
                bio: "Con una distinguida trayectoria militar como General de Brigada (Res') y un espíritu emprendedor visionario que fomenta los lazos económicos entre Israel y Canadá, Benda, nuestro Director de Estrategia, nos impulsa hacia nuevos niveles de éxito."
            },
            {
                name: "Kartik Khatri",
                title: "Asistente Ejecutivo",
                linkedin: "kartikkhatri",
                bio: "El primer estudiante en obtener una triple licenciatura en matemáticas, estadística y economía en la Universidad de Toronto. Es un cerebrito y tiene múltiples trucos bajo la manga para aprovechar en la empresa.",
            },
            {
                name: "Peter Norvig",
                title: "Asesor",
                linkedin: "pnorvig",
                bio: "Peter Norvig, distinguido colega de educación en Stanford y ex Director de Investigación de Google, es un asesor altamente estimado para F8th Inc. Su experiencia en IA, NLP y aprendizaje automático aporta conocimientos invaluables a nuestra organización.",
            },
            {
                name: "Mark Smith",
                title: "Asesor",
                linkedin: "smithamark",
                bio: "Ex Director en Amazon, inversor de capital de riesgo, socio en BDC, mentor y entrenador, Mark está ayudando a F8th con estrategias de desarrollo empresarial.",
            },
            {
                name: "Bradley Schaufenbuel",
                title: "Asesor",
                linkedin: "bradleyschaufenbuel",
                bio: "Bradley J. Schaufenbuel, Vicepresidente y Director de Seguridad de la Información de Paychex, es un asesor increíble y generoso con una impresionante trayectoria en seguridad de la información, gobernanza y derecho.",
            },
            {
                name: "Lee Bowie",
                title: "Asesor",
                linkedin: "lee-bowie",
                bio: "Líder del Equipo Nacional de IBM Cloud y Tecnología Cognitiva en Canadá. Lee es amigo y un asesor clave para la dirección estratégica e integración de F8th en las tecnologías en la nube.",
            },
            {
                name: "Garry Chan",
                title: "Asesor",
                linkedin: "garrychan1",
                bio: "Emprendedor en serie durante muchos años con un profundo conocimiento de las tecnologías innovadoras, Garry es un asesor clave en las estrategias de crecimiento empresarial de F8th.",
            },
            {
                name: "Caroline Belisle Therrien",
                title: "Asesora",
                linkedin: "carolinebelisletherrien",
                bio: "Caroline es una asesora excepcional con amplios conocimientos en Fintech y ciberseguridad, aportando experiencia inestimable y una pasión por estar al día con los últimos avances tecnológicos.",
            },
            {
                name: "Samuel Lemay",
                title: "Asesor",
                linkedin: "samlemay",
                bio: "Anteriormente desempeñando el cargo de Director Comercial en F8th Inc., Samuel aporta una gran experiencia en comercialización global de tecnología, lo que lo convierte en un asesor invaluable para la empresa.",
            },
            {
                name: "Sebastien Roy",
                title: "Asesor",
                linkedin: "sebastienroy",
                bio: "La experiencia de Sebastien en matemáticas, optimización y ciencia de datos, combinada con habilidades de liderazgo y experiencia en startups, lo convierten en un valioso asesor para el crecimiento de la empresa."
            },
            // {
            //     name: "Nadia Tahiri",
            //     title: "Asesora",
            //     linkedin: "tahiri-nadia",
            //     bio: "La Dra. Nadia Tahiri, PhD, es una valiosa asesora para F8th Inc., aportando experiencia en informática, aprendizaje automático y bioinformática. Su experiencia como profesora e investigadora brinda una orientación perspicaz.",
            // },
        ],
    },
    fr: {
        id: "fr",
        label: "Français",
        clear: "effacer",
        contact: "Contacter",
        days: "Jours",
        email: "Adresse Courriel",
        firstName: "Prénom",
        home: "Accueil",
        hours: "Heures",
        info: "Info",
        lastName: "Nom",
        logo: "Logo",
        message: "Message",
        minutes: "Minutes",
        news: "Actualité",
        privacy: "Confidentialité",
        seconds: "Secondes",
        send: "envoyer",
        team: "Équipe",
        video: "Vidéo",
        sentences: {
            contactUs: "Contactez Nous",
            emailErrorMessage: "SVP contactez le support à la clientèle au <a href='mailto://support@f8th.ai'>support@f8th.ai</a>.",
            emailErrorTitle: "Oops... Le courriel n'a pas été envoyé!",
            emailPolicy: "En cliquant sur <span class='colored'>ENVOYER</span>, vous reconnaissez que vous avez lu notre plus récente <span class='colored'>POLITIQUE DE CONFIDENTIALITÉ</span>, et que votre utilisation continue du site Web est soumise à ces politiques.",
            emailSent: "Le courriel a été envoyé!... Merci!",
            meetOurTeam: "Rencontrez notre Équipe",
            partnerWith: "Partenaire avec",
            pleaseWait: "SVP attendez...",
            pleaseWrite: "SVP veuillez écrire votre",
            seedRoundCountdown: "Compte à Rebours du Round",
        },
        slides: [
			{
				title: "Plus de Protection avec Moins de Complications",
				subtitle: "Protège de manière passive et continue contre les prises de contrôle de compte et de session, les bots web et les menaces internes."
			},
			{
				title: "Renforcez votre Architecture Zero Trust (ZTA)",
				subtitle: "Améliorez votre sécurité avec les biométrie comportementales de F8th pour l'Architecture Zero Trust."
			},
			{
				title: "Authentification Continue",
				subtitle: "Authentifie de manière transparente et passive les utilisateurs et détecte les fraudeurs en temps réel sans impact sur l'expérience utilisateur."
			},
			{
				title: "Biométrie Non Invasive avec Brevet en Attente",
				subtitle: "Nouvelle génération de biométries comportementales pour une sécurité renforcée."
			}
		],
		infoSlides: [
			{
				title: "Une Protection Simple",
				description: "Expérimentez une sécurité renforcée avec la solution de biométries comportementales de F8th Inc. Notre authentification continue sécurise vos comptes et sessions, vous protégeant contre les prises de contrôle, les bots et les attaques internes. Obtenez une protection solide sans les complications des processus complexes."
			},
			{
				title: "Renforcement de ZTA",
				description: "Renforcez votre Architecture Zero Trust (ZTA) avec la solution avancée de biométries comportementales de F8th Inc. Notre technologie offre une authentification continue, renforçant votre posture de sécurité et protégeant contre les prises de contrôle de compte et les menaces internes. Renforcez dès aujourd'hui le cadre de sécurité de votre organisation."
			},
			{
				title: "Authentification Continue",
				description: "Rehaussez vos mesures de sécurité avec l'authentification continue de F8th Inc. Grâce aux biométries comportementales, notre solution garantit un processus d'authentification fluide et hautement sécurisé. Prenez une mesure proactive pour protéger vos actifs numériques."
			},
			{
				title: "Innovation en Biométrie Non Invasive",
				description: "Découvrez le futur de la sécurité renforcée avec la solution de biométrie non invasive en attente de brevet de F8th Inc. Nos biométrie comportementales avancées offrent une protection de pointe contre les menaces sans compromettre la confidentialité des utilisateurs. Restez en avance avec notre approche innovante."
			}
		],
        investorPanels: [
            {
                title: "Investisseurs<br />Considérés",
                description: "Plus de 1000 fonds de VC ont été identifiés comme partenaires potentiels ayant investi sur un SEED round dans les domaines de la Fintech et de la Cybersécurité."
            },
            {
                title: "Connexions<br />Établies",
                description: "Suite à une sélection rigoureuse basée sur des critères précis, plusieurs VCs ont été informés que nous allons bientôt lancer une ronde de financement."
            },
            {
                title: "Profiles<br />Compatibles",
                description: "Après avoir rencontré des partenaires potentiels, une décision commune est prise pour confirmer l'intérêt des deux parties."
            },
            {
                title: "Engagements<br />Souples",
                description: "Nous acceptons des engagements souples avant d'ouvrir la levée de fond. De cette façon, nous savons qui veut faire partie de cette révolution en  cybersécurité!"
            },
        ],
        teamPanels: [
            {
                name: "Jonathan Gagné",
                title: "Fondateur/PDG",
                linkedin: "jonathan-gagne",
                bio: "Avec une expertise approfondie en cybersécurité, en génie logiciel et en science des données, Jonathan dirige le développement commercial et technologique de F8th.",
            },
            {
                name: "Vivene Salmon",
                title: "Co-fondatrice/Directrice juridique",
                linkedin: "vivene-salmon-gagne",
                bio: "Ancienne présidente de l'Association du Barreau canadien et responsable de la protection de la vie privée à la Bank of America, Vivene a été nominée « L'une des 25 avocates les plus influentes au Canada ».",
            },
            {
                name: "Stephen Strome",
                title: "CTO",
                linkedin: "stephen-strome-27187010b",
                bio: "Stephen, CTO de F8th, est non seulement un professionnel hautement qualifié, mais aussi un confident de confiance du PDG, avec des années d'amitié collaborative.",
            },
            {
                name: "Daniel Steeves",
                title: "DSI",
                linkedin: "daniel-steeves-1527b55",
                bio: "Anciennement DSI au Service de police d'Ottawa et officier militaire de la Défense nationale, Daniel a rejoint l'équipe de F8th pour apporter son expertise à l'entreprise.",
            },
            {
                name: "Nir Ben-David",
                title: "CSO",
                linkedin: "benda-ican",
                bio: "Fort d'un parcours militaire distingué en tant que Général de Brigade (Res') et d'un esprit d'entrepreneuriat visionnaire favorisant les liens économiques entre Israël et le Canada, Benda, notre directeur de la stratégie, nous propulse vers de nouveaux sommets de réussite."
            },
            {
                name: "Kartik Khatri",
                title: "Assistant exécutif",
                linkedin: "kartikkhatri",
                bio: "Premier étudiant à obtenir un triple diplôme en mathématiques, statistiques et économie à l'Université de Toronto. C'est une personne intelligente et il possède plusieurs astuces dans son sac pour tirer parti de l'entreprise.",
            },
            {
                name: "Peter Norvig",
                title: "Conseiller",
                linkedin: "pnorvig",
                bio: "Peter Norvig, éminent membre du corps enseignant de l'Université Stanford et ancien directeur de la recherche chez Google, est un conseiller très estimé pour F8th Inc. Son expertise en IA, en traitement du langage naturel et en apprentissage automatique apporte des idées inestimables à notre organisation.",
            },
            {
                name: "Mark Smith",
                title: "Conseiller",
                linkedin: "smithamark",
                bio: "Ancien directeur chez Amazon, investisseur en capital-risque, partenaire chez BDC, mentor et coach, Mark aide F8th à élaborer des stratégies de développement commercial.",
            },
            {
                name: "Bradley Schaufenbuel",
                title: "Conseiller",
                linkedin: "bradleyschaufenbuel",
                bio: "Bradley J. Schaufenbuel, vice-président et responsable de la sécurité des systèmes d'information chez Paychex, est un conseiller incroyable et généreux, doté d'une expérience impressionnante en matière de sécurité de l'information, de gouvernance et de droit.",
            },
            {
                name: "Lee Bowie",
                title: "Conseiller",
                linkedin: "lee-bowie",
                bio: "Leader de l'équipe nationale IBM Cloud and Cognitive Technology Canada. Lee est un ami et un conseiller clé pour l'orientation stratégique et l'intégration de F8th dans les technologies cloud.",
            },
            {
                name: "Garry Chan",
                title: "Conseiller",
                linkedin: "garrychan1",
                bio: "Entrepreneur en série depuis de nombreuses années, doté d'une compréhension approfondie des technologies innovantes, Garry est un conseiller clé pour les stratégies de croissance commerciale de F8th.",
            },
            {
                name: "Caroline Belisle Therrien",
                title: "Conseillère",
                linkedin: "carolinebelisletherrien",
                bio: "Caroline est une conseillère exceptionnelle possédant une connaissance approfondie de la fintech et de la cybersécurité, apportant une expertise inestimable et une passion pour rester à jour avec les dernières avancées technologiques.",
            },
            {
                name: "Samuel Lemay",
                title: "Conseiller",
                linkedin: "samlemay",
                bio: "Ancien directeur commercial en chef de F8th Inc., Samuel apporte une grande expertise en commercialisation mondiale de technologies, ce qui en fait un conseiller inestimable pour l'entreprise.",
            },
            {
                name: "Sebastien Roy",
                title: "Conseiller",
                linkedin: "sebastienroy",
                bio: "L'expertise de Sébastien en mathématiques, optimisation et science des données, combinée à ses compétences en leadership et à son expérience des start-ups, font de lui un conseiller précieux pour le développement de l'entreprise."
            },
            // {
            //     name: "Nadia Tahiri",
            //     title: "Conseillère",
            //     linkedin: "tahiri-nadia",
            //     bio: "Le Dr Nadia Tahiri, titulaire d'un doctorat, est une conseillère précieuse pour F8th Inc., apportant son expertise en informatique, en apprentissage automatique et en bioinformatique. Son expérience en tant que professeure et chercheuse offre des orientations pertinentes.",
            // },
        ]
    },
    he: {
        id: "he",
        label: "עברית",
        clear: "נקה",
        contact: "צור קשר",
        days: "ימים",
        email: "דואר אלקטרוני",
        firstName: "שם פרטי",
        home: "דף הבית",
        hours: "שעות",
        info: "מידע",
        lastName: "שם משפחה",
        logo: "לוגו",
        message: "הודעה",
        minutes: "דקות",
        news: "חדשות",
        privacy: "פרטיות",
        seconds: "שניות",
        send: "שלח",
        team: "צוות",
        video: "וידאו",
        sentences: {
            contactUs: "צור קשר",
            emailErrorMessage: "נא ליצור קשר עם שירות הלקוחות בכתובת הדוא''ל <a href='mailto://support@f8th.ai'>support@f8th.ai</a>.",
            emailErrorTitle: "אופס... הדוא''ל לא נשלח!",
            emailPolicy: "בלחיצה על <span class='colored'>שלח</span>, אתה מכיר בכך שקראת את <span class='colored'>מדיניות הפרטיות</span> המעודכנת שלנו וששימושך המתמשך באתר כפוף למדיניות זו.",
            emailSent: "הדוא''ל נשלח... תודה!",
            meetOurTeam: "פגש את הצוות שלנו",
            partnerWith: "בשותפות עם",
            pleaseWait: "נא להמתין...",
            pleaseWrite: "נא לכתוב את",
            seedRoundCountdown: "ספירת הקרן",
        },
        slides: [
            {
                title: "הגנה מורחבת עם פחות רמות מורכבות",
                subtitle: "מגן באופן פסיבי ותמידי על פני חשבונות והפניות, בוטים רשת ואיומים פנימיים."
            },
            {
                title: "חזק את מימד הבטחון שלך",
                subtitle: "חזק את ארכיטקטורת האמון האפסי (Zero Trust Architecture) שלך עם הזדהות סבירת מידע למדת F8th."
            },
            {
                title: "הזהה באופן מתמיד",
                subtitle: "מזהה משתמשים באופן פסיבי ומזהה הונאתי בזמן אמת בלתי ניכר במהלך תהליך החוויה."
            },
            {
                title: "טכנולוגיית ביומטריה לא פוגעת בפטנט",
                subtitle: "ביומטריה התנהגותית דור הבא לביטחון משופר."
            }
        ],
        infoSlides: [
            {
                title: "הגנה מורחבת",
                description: "חווי ביטחון משופר עם פתרון הביומטריה התנהגותית של F8th Inc. הזיהוי המתמיד שלנו מגן על חשבונות והפניות שלך ומגן עליהם מפני איומים כגון התפשטויות, בוטים רשת ותוקפים פנימיים. תקבל הגנת ביטחון חזקה בלי הטרחה של תהליכים מורכבים."
            },
            {
                title: "חיזוק ארכיטקטורת האמון האפסי (ZTA)",
                description: "חזק את ארכיטקטורת האמון האפסי (ZTA) שלך עם פתרון הביומטריה התנהגותית המתקדם של F8th Inc. הטכנולוגיה שלנו מספקת הזדהות מתמידה, שמחזקת את מערכת האבטחה שלך ומגן מפני התפשטויות של חשבונות ואיומים פנימיים. חזק את מסגרת האבטחה של הארגון שלך היום."
            },
            {
                title: "הזהיה מתמידה",
                description: "שדרג את האבטחה שלך עם הזהיה המתמידה של F8th Inc. על ידי השימוש בביומטריה התנהגותית שלנו, הפתרון שלנו מבטיח הזהיה חלקה ובטוחה ביותר. קח צעד פרואקטיבי לשמירה על נכסים דיגיטליים."
            },
            {
                title: "חדשנות בביומטריה",
                description: "חווה את עתיד האבטחה המשופרת עם פתרון הביומטריה התנהגותית לא פוגעת בפטנט של F8th Inc. ביומטריה התנהגותית המתקדמת שלנו מספקת הגנה מתקדמת מפני איומים בלתי נראים, בלתי תוקפים פנימיים ובלתי תוקפים בפרטיות המשתמשים. הישאר צעד אחד מתחילה עם גישתנו החדשנית."
            }
        ],
        investorPanels: [
            {
                title: "משקיעים<br />שמומלצים",
                description: "יותר מ-1000 קרנות VC זוהו כשותפים פוטנציאליים שהשקיעו בסיבובי הגעת זרע בתחום הפינטק או הסייבר."
            },
            {
                title: "חיבורים<br />מוכרים",
                description: "בהתבסס על קריטריונים ממוקדים יותר, קרנות VC התרשמו כי אנחנו פותחים סיבוב בקרוב."
            },
            {
                title: "פרופילים<br />תואמים",
                description: "לאחר פגישות עם שותפים פוטנציאליים, נקבעה החלטה משותפת לאישור עניין משני הצדדים."
            },
            {
                title: "התחייבויות<br />רכות",
                description: "אנחנו מקבלים התחייבויות רכות לפני פתיחת הסיבוב. כך אנחנו יודעים מי רוצה להיות חלק ממהפכת הסייברסיקיוריטי!"
            },
        ],
        teamPanels: [
            {
                name: "יונתן גאגנה",
                title: "מייסד/מנכ\"ל",
                linkedin: "jonathan-gagne",
                bio: "עם מומחיות מעמיקה בסייברבטית, הנדסת תוכנה ומדעי הנתונים, יונתן מוביל את הפיתוח העסקי והטכנולוגי של F8th.",
            },
            {
                name: "ויוין סאלמון",
                title: "מייסדת/סגנית מנהלת משפטית",
                linkedin: "vivene-salmon-gagne",
                bio: "בעברה הייתה נשיאת אגודת המשפטנים הקנדית ועו\"ד פרטי בבנק אמריקה, וואיוין זוכת « העורכים 25 המשפיעים ביותר בקנדה ».",
            },
            {
                name: "סטיבן סטרום",
                title: "מנהל טכנולוגיה",
                linkedin: "stephen-strome-27187010b",
                bio: "סטיבן, מנהל טכנולוגיה ב-F8th, הוא לא רק מקצוען מיומן אלא גם ידיד נאמן של המנכ\"ל, עם שנות ידידות שיתופיות.",
            },
            {
                name: "דניאל סטיבס",
                title: "מנהל מערכות מידע",
                linkedin: "daniel-steeves-1527b55",
                bio: "בעברו היה מנהל מערכות מידע של משטרת אוטווה וקצין בחיל ההגנה הלאומית, דניאל הצטרף לצוות של F8th כדי להביא את המומחיות שלו לחברה.",
            },
            {
                name: "ניר בן-דוד",
                title: "ראש מחלקה לאסטרטגיה",
                linkedin: "benda-ican",
                bio: "עם רקע צבאי מצטיין כתת-אלוף (מיל') ויזמות חזונית המקדמת קשרים כלכליים בין ישראל לקנדה, בנדה, ראש האסטרטגיה שלנו, מדריך אותנו לגבהים חדשים של הצלחה."
            },
            {
                name: "קרטיק כאטרי",
                title: "עוזר ניהולי",
                linkedin: "kartikkhatri",
                bio: "הסטודנט הראשון שקיבל תואר שלושה בתחום המתמטיקה, הסטטיסטיקה והכלכלה באוניברסיטת טורונטו. הוא חכם ויש לו מספר כלים בכובעו ליצור תרומה לחברה.",
            },
            {
                name: "פיטר נורוויג",
                title: "יועץ",
                linkedin: "pnorvig",
                bio: "פיטר נורוויג, חבר אקדמיה יקר בסטנפורד ומנהל מחקר בעברו בגוגל, הוא יועץ מוערך מאוד ל-F8th Inc. המומחיות שלו בתחום הבינה מלאכותית, NLP ולמידת מכונה מביאה לארגון שלנו תובנות בלתי יקרות.",
            },
            {
                name: "מארק סמית",
                title: "יועץ",
                linkedin: "smithamark",
                bio: "בעברו היה מנהל ב-Amazon, משקיע בקרנות השקעות, שותף ב-BDC, מנחה ומאמן. מארק עוזר ל-F8th עם אסטרטגיות פיתוח העסק.",
            },
            {
                name: "בראדלי שופנבואל",
                title: "יועץ",
                linkedin: "bradleyschaufenbuel",
                bio: "בראדלי ג'יי שופנבואל, הנשיא המשנה וראש המוסד לאבטחת מידע בחברת Paychex, הוא יועץ מדהים ונדיב עם רקע מרשים באבטחת מידע, בשלטון ובחוק.",
            },
            {
                name: "לי בואווי",
                title: "יועץ",
                linkedin: "lee-bowie",
                bio: "ראש צוות המדור הלאומי לטכנולוגיות ענן וקוגניטיביות של IBM בקנדה. לי הוא חבר ויועץ מרכזי לכיוון האסטרטגי והשלמת F8th בטכנולוגיות ענן.",
            },
            {
                name: "גארי צ'אן",
                title: "יועץ",
                linkedin: "garrychan1",
                bio: "יזם סדיר במשך שנים רבות עם הבנה עמוקה של טכנולוגיות חדשניות, גארי הוא יועץ מרכזי לאסטרטגיות הצמיחה העסקית של F8th.",
            },
            {
                name: "קרולין בליזל תריאן",
                title: "יועצת",
                linkedin: "carolinebelisletherrien",
                bio: "קרולין היא יועצת יוצאת דופן עם ידע נרחב בפינטק ובסייברסיקיוריטי, והיא מביאה מומחיות בלתי יקרה ותשוקה להישאר מעודכנת עם המתקדמות הטכנולוגיות האחרונות.",
            },
            {
                name: "סמואל למאי",
                title: "יועץ",
                linkedin: "samlemay",
                bio: "כששימש כקצין מסחרי בכיר של F8th Inc., סמואל מביא עימו עשרות שנות ניסיון במסחר טכנולוגיות גלובלי, מה שהופך אותו ליועץ בלתי יקר לחברה.",
            },
            {
                name: "סבסטיאן רוואה",
                title: "יועץ",
                linkedin: "sebastienroy",
                bio: "התמחותו של סבסטיאן במתמטיקה, אופטימיזציה ומדע נתונים, בשילוב עם יכולות הנהגה וניסיון בתחום הסטארט-אפ, הופכים אותו ליועץ יקר להתרחבות החברה."
            },
            // {
            //     name: 'נדיה טהירי',
            //     title: 'יועצת',
            //     linkedin: 'tahiri-nadia',
            //     bio: 'ד"ר נדיה טהירי, דוקטורת פילוסופיה, היא יועצת מוערכת לחברת F8th Inc., המביאה מומחיות במדעי המחשב, למידת מכונה וביו-מערכתיקה. ניסיון העבודה שלה כפרופסורית וחוקרת מספק כוונה מתמקדת.',
            // },
        ]
    },
}